import { Component, computed, inject, input, signal } from '@angular/core';
import { UiComponentsModule } from '@mwe/ui/components';
import { ROUTE_HOME, routePrefix } from '../../app.constants';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-ikp-top-page',
  standalone: true,
  imports: [UiComponentsModule],
  templateUrl: './top-page.component.html',
})
export class TopPageComponent {
  private readonly router = inject(Router);
  readonly title = input<string>();
  readonly subtitle = input<string>();
  readonly showGoBackLink = input<boolean>(true);
  readonly goBackLink = input<string>();
  readonly classes = input<string>();
  readonly backLinkLabel = input<string>('global.topPageBackLabel');
  readonly isHome = computed(() => signal(this.router.url)() === routePrefix(ROUTE_HOME));

  backLinkPath = computed(() => {
    const goBackLink = this.goBackLink();
    if (goBackLink) {
      return goBackLink;
    }
    return routePrefix(ROUTE_HOME);
  });
}
